type AuthOverlayController = {
  open: () => void;
  close: () => void;
};

let controller: AuthOverlayController | null = null;

/** Web-only: Auth is an overlay so MainTabs stays visible (no gray stack card). */
export function registerAuthOverlayController(next: AuthOverlayController | null): void {
  controller = next;
}

export function openAuthOverlay(): boolean {
  if (!controller) return false;
  controller.open();
  return true;
}

export function closeAuthOverlay(): boolean {
  if (!controller) return false;
  controller.close();
  return true;
}
